export default "__VITE_ASSET__B5nyHR2a__"